import VueWrapper from '@/components/core/Vue/vue.wrapper';
import PaymentAppBarComponent from '@/components/vuetify/payment-app-bar/payment-app-bar.component';
import {Component} from 'vue-property-decorator';

@Component({
    components: {
        PaymentAppBarComponent,
    },
})
export default class PaymentLayoutComponent extends VueWrapper {}
